import { usePatientFiIntegration } from "./usePatientFiIntegration";

export const usePfiConfigs = () => {
  const { data } = usePatientFiIntegration();
  const configs = data?.configs || [];
  const pfiPractices = data?.pfiPractices || [];
  const clinics = data?.clinics || [];

  const formattedClinics = clinics.map((clinic) => ({
    value: clinic.id,
    label: clinic.name,
  }));

  const formattedConfigs = configs.map((config) => {
    const practice = pfiPractices.find((p) => p.id === config.pfiPracticeId);
    const clinic = clinics.find((c) => c.id === config.clinicId);
    return {
      ...config,
      name: practice?.name,
      clinic:
        config.clinicId > 0 ? { label: clinic?.name, value: clinic?.id } : null,
    };
  });

  return { pfiConfigs: formattedConfigs, clinics: formattedClinics };
};
